import gql from 'graphql-tag'

const AllEmailAddresses = gql`
  query AllEmails($substring: String!) {
    allEmails(substring: $substring)
  }
`

export { AllEmailAddresses }


// WEBPACK FOOTER //
// ./src/queries/AllEmailAddresses.js